import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialModel, Media } from "typings/microserviceModels/content-flex-module";
import { UitkImage } from "uitk-react-images";

export class ImageEditorial extends EditorialBase {
  /* istanbul ignore next */
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate() {
    return (
      <div id={this.flexComponent.id} data-fm={this.flexComponent.fmId} data-fm-title-id={this.flexComponent.fmTitleId}>
        {this.editorial.items
          .filter((item: EditorialModel) => item.media && item.media.filter(media => media.mediaUrl))
          .map((item: EditorialModel) => item.media)
          .reduce((item, acum) => acum && acum.concat.apply(acum, item), [])
          .map(({ mediaUrl, mediaAlt }: Media) => {
            return <UitkImage key={mediaUrl} alt={mediaAlt} src={mediaUrl} className="editorialImage" />;
          })}
      </div>
    );
  }
}

export default ImageEditorial;
